// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"ae219698","905":"97965efe"}[chunkId] + ".chunk.js";
};